export function installDemo(config) {
  if (window.__hltvConceptDemo) {
    window.__hltvConceptDemo.close();
    return;
  }
  const host = document.createElement("div");
  host.style.cssText = "position:fixed;right:14px;top:14px;z-index:2147483647";
  const shadow = host.attachShadow({ mode: "open" });
  shadow.innerHTML =
    '<style>:host{all:initial}*{box-sizing:border-box}section{background:#fff;color:#32283f;border:1px solid #d5cce1;border-top:3px solid #765596;border-radius:10px;padding:16px;width:276px;max-width:calc(100vw - 28px);max-height:calc(100vh - 28px);overflow:auto;font:12px Arial,sans-serif;box-shadow:0 8px 32px #0006}h2{margin:0 0 12px;font-size:14px}p{font-size:11px;line-height:1.5;color:#746b7e}label{display:block;font-size:10px;margin:12px 0 4px}select,button{font:11px Arial,sans-serif;padding:8px;background:#f5f1fa;color:#533584;border:1px solid #d5cce1;border-radius:5px;cursor:pointer}select{width:100%;min-width:0}.settings{display:grid;grid-template-columns:1fr 1fr;gap:10px}.summary{margin:10px 0 0;padding:10px;background:#f8f5fc;border-left:2px solid #9874ce;color:#594c68}.row{display:flex;gap:5px;margin-top:10px}.row button{flex:1}button:focus-visible,select:focus-visible{outline:2px solid #7759b6}#status:empty{display:none}#restore{display:none}section.mini>*{display:none}section.mini{width:auto;padding:0}section.mini #restore{display:block;border:0;padding:12px}</style><section><h2>Demo controls</h2><p id="hint">Select the existing player to replace it locally. Esc cancels.</p><label for="concept">Variant</label><select id="concept" aria-describedby="summary"></select><p id="summary" class="summary" role="status" hidden></p><div class="settings"><div><label for="geo">Viewer country</label><select id="geo"><option value="DE">Germany</option><option value="US">United States</option><option value="GB">United Kingdom</option><option value="CA">Canada</option><option value="SE">Sweden</option><option value="DK">Denmark</option><option value="BR">Brazil</option><option value="FI">Finland</option><option value="">Automatic</option></select></div><div><label for="size">Viewport</label><select id="size"><option value="638">Desktop</option><option value="375">Mobile</option></select></div></div><p id="status" role="status"></p><div class="row"><button id="endcard">Clip ending</button></div><div class="row"><button id="minimize">Hide panel</button><button id="close">Close</button></div><button id="restore">Demo controls ＋</button></section>';
  document.body.append(host);
  const el = (id) => shadow.getElementById(id);
  config.concepts.forEach(([value, name]) => {
    const option = document.createElement("option");
    option.value = value;
    option.textContent = name;
    el("concept").append(option);
  });
  el("concept").value = config.concept;
  function describeConcept() {
    const summary =
      config.concepts.find(([id]) => id === el("concept").value)?.[2] || "";
    el("summary").textContent = summary;
    el("summary").hidden = !summary;
  }
  describeConcept();
  const geo = config.geo ?? "DE";
  if (![...el("geo").options].some((option) => option.value === geo)) {
    const option = document.createElement("option");
    option.value = option.textContent = geo;
    el("geo").append(option);
  }
  el("geo").value = geo;
  let frame,
    target,
    oldDisplay,
    outline,
    hovered,
    picking = false,
    width = 638;
  const pointerStyles = new Map();
  function command(action, value) {
    frame?.contentWindow?.postMessage(
      { type: "hltv-demo-command", action, value },
      new URL(config.base).origin,
    );
  }
  function stopPick() {
    picking = false;
    outline?.remove();
    document.removeEventListener("mousemove", move, true);
    document.removeEventListener("click", pick, true);
    for (const [node, style] of pointerStyles) node.style.pointerEvents = style;
    pointerStyles.clear();
  }
  function restore() {
    frame?.remove();
    frame = null;
    if (target) target.style.display = oldDisplay;
    target = null;
  }
  function close() {
    stopPick();
    restore();
    host.remove();
    document.removeEventListener("keydown", key, true);
    window.removeEventListener("message", message);
    delete window.__hltvConceptDemo;
  }
  function move(event) {
    if (event.composedPath().includes(host)) return;
    hovered =
      Array.from(pointerStyles.keys()).find((node) => {
        const r = node.getBoundingClientRect();
        return (
          event.clientX >= r.left &&
          event.clientX <= r.right &&
          event.clientY >= r.top &&
          event.clientY <= r.bottom
        );
      }) || document.elementFromPoint(event.clientX, event.clientY);
    if (
      !hovered ||
      hovered === document.body ||
      hovered === document.documentElement
    )
      return;
    const r = hovered.getBoundingClientRect();
    outline.style.cssText = `position:fixed;pointer-events:none;z-index:2147483646;border:2px solid #9874ce;background:#9874ce22;top:${r.top}px;left:${r.left}px;width:${r.width}px;height:${r.height}px;box-sizing:border-box`;
  }
  function pick(event) {
    if (
      event.composedPath().includes(host) ||
      !hovered ||
      hovered === document.body ||
      hovered === document.documentElement ||
      hovered.contains(host)
    )
      return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const selected = hovered;
    stopPick();
    restore();
    target = selected;
    oldDisplay = target.style.display;
    frame = document.createElement("iframe");
    frame.title = "HLTV highlights concept";
    frame.allow = "autoplay; fullscreen";
    const query = new URLSearchParams({
      embed: "1",
      v: "5",
      concept: el("concept").value,
      geo: el("geo").value,
    });
    for (const key of ["playlist", "region", "previewCampaignId"])
      if (config[key]) query.set(key, config[key]);
    frame.src = `${config.base}/demo/hltv-bookmarklet?${query}`;
    frame.onload = () => {
      command("concept", el("concept").value);
    };
    el("status").textContent = "Loading live playlist…";
    frame.style.cssText = `width:${width}px;max-width:100%;height:226px;border:0;display:block;background:#1b2026`;
    target.parentNode.insertBefore(frame, target);
    target.style.display = "none";
    el("hint").textContent =
      "Preview only. Close restores the original player.";
  }
  function startPick() {
    stopPick();
    hovered = null;
    picking = true;
    outline = document.createElement("div");
    document.body.append(outline);
    document.querySelectorAll("iframe").forEach((node) => {
      if (node !== frame) {
        pointerStyles.set(node, node.style.pointerEvents);
        node.style.pointerEvents = "none";
      }
    });
    document.addEventListener("mousemove", move, true);
    document.addEventListener("click", pick, true);
    el("hint").textContent =
      "Select the existing player to replace it locally. Esc cancels.";
  }
  function key(event) {
    if (event.key === "Escape") {
      if (picking && frame) {
        stopPick();
        el("hint").textContent = "Placement unchanged.";
      } else close();
    }
  }
  function message(event) {
    if (
      event.source !== frame?.contentWindow ||
      event.origin !== new URL(config.base).origin
    )
      return;
    if (event.data?.type === "hltv-demo-status")
      el("status").textContent = String(event.data.value);
    if (event.data?.type === "hltv-demo-height") {
      const h = Number(event.data.value);
      if (Number.isFinite(h) && h >= 100 && h <= 1000)
        frame.style.height = `${h}px`;
    }
  }
  el("concept").onchange = () => {
    describeConcept();
    command("concept", el("concept").value);
  };
  el("geo").onchange = () => {
    config.geo = el("geo").value;
    delete config.region;
    command("geo", config.geo);
  };
  el("size").onchange = () => {
    width = Number(el("size").value);
    if (frame) frame.style.width = width + "px";
  };
  el("endcard").onclick = () => command("jump", "endcard");
  el("close").onclick = close;
  el("minimize").onclick = () =>
    shadow.querySelector("section").classList.add("mini");
  el("restore").onclick = () =>
    shadow.querySelector("section").classList.remove("mini");
  document.addEventListener("keydown", key, true);
  window.addEventListener("message", message);
  window.__hltvConceptDemo = { close };
  startPick();
}
export function buildBookmarklet(config) {
  return `javascript:${encodeURIComponent(
    `(${installDemo.toString()})(${JSON.stringify(config)})`,
  )}`;
}
